import { render, staticRenderFns } from "./procurement_procedure_protocol.vue?vue&type=template&id=39275bd2&scoped=true"
import script from "./procurement_procedure_protocol.vue?vue&type=script&lang=js"
export * from "./procurement_procedure_protocol.vue?vue&type=script&lang=js"
import style0 from "./procurement_procedure_protocol.vue?vue&type=style&index=0&id=39275bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39275bd2",
  null
  
)

export default component.exports